import { CSSProperties } from "react";

const SimpleCartCustomer = ({
    dynamicData,
    customerIcon,
    closeCustomerIcon,
    onClose,
    onEdit,
    customerTypography,
    customerChipStyle,
    prepend,
    append,
    fallback
}: {
    dynamicData: string;
    customerIcon?: any;
    closeCustomerIcon?: any;
    onClose?: () => void;
    onEdit?: () => void;
    customerTypography: CSSProperties;
    customerChipStyle: CSSProperties;
    prepend: { style: CSSProperties; value: string };
    append: { style: CSSProperties; value: string };
    fallback: { style: CSSProperties; value: string };
}) => {
    return (
        <div className="customer-box" onClick={onEdit} style={customerChipStyle}>
            <div className="customer-details" style={customerTypography}>
                {customerIcon}
                <p>
                    {prepend?.value && <span style={prepend?.style}>{prepend?.value}</span>}
                    {dynamicData || <span style={fallback?.style}>{fallback?.value}</span>}
                    {append?.value && <span style={append?.style}>{append?.value}</span>}
                </p>
            </div>
            <div
                onClick={e => {
                    e.stopPropagation();
                    onClose && onClose();
                }}
            >
                {closeCustomerIcon}
            </div>
        </div>
    );
};

export default SimpleCartCustomer;
